import { Tab, Theme, createStyles, withStyles } from '@material-ui/core';

const styles = (theme: Theme) =>
  createStyles({
    root: {
      fontSize: theme.typography.body2.fontSize,
      paddingBottom: theme.spacing(1),
      minHeight: 0,
    },
  });

export default withStyles(styles)(Tab);
